<template>
  <div>

    <vs-row v-if="prevPost.postId !== 0 || nextPost.postId !== 0 ">
      <vs-col class="header-tool mb-8" vs-type="flex" vs-justify="flex-end">
        <span v-if="prevPost.postId !== 0" @click="handleClickPrevPost">&lt; 이전글</span>
        <span v-if="prevPost.postId !== 0 && nextPost.postId !== 0 ">|</span>
        <span v-if="nextPost.postId !== 0" @click="handleClickNextPost">다음글 &gt;</span>
      </vs-col>
    </vs-row>

    <!-- 상세내용 -->
    <vx-card class="mb-8">

      <!-- 글 작성 정보 -->
      <vs-row class="read-layout-flex">
        <div class="flex" style="display: flex !important; flex-wrap: wrap;">
          <vs-col class="read-layout-item">
            <h5 class="title">작성자</h5>
            <span class="content">{{ (post.author ? post.author.username : '') }}</span>
          </vs-col>

          <vs-col class="read-layout-item">
            <h5 class="title">이메일</h5>
            <span class="content">{{ (post.author ? post.author.email : '') }}</span>
          </vs-col>

          <vs-col class="read-layout-item">
            <h5 class="title">구분</h5>
            <span class="content">회원가입</span>
          </vs-col>

          <vs-col class="read-layout-item">
            <h5 class="title">작성일</h5>
            <span class="content">{{ post.created_at }}</span>
          </vs-col>
        </div>

        <div class="ml-auto flex" style="align-items: center">본문이동</div>

      </vs-row>

      <!--    구분선 -->
      <vs-divider></vs-divider>

      <!--    제목-->
      <vs-row class="read-layout-2">
        <vs-col class="read-layout-title">제목</vs-col>
        <vs-col>
          <span class="float-left">{{ post.post_title }}</span>
        </vs-col>
      </vs-row>

      <!--    내용-->
      <vs-row class="read-layout-2">
        <vs-col class="read-layout-title top">내용</vs-col>
        <vs-col>
          <div class="content-read" v-html="post.post_content"></div>
        </vs-col>
      </vs-row>

      <!--    구분선 -->
      <vs-divider v-if="post.post_attachment && post.post_attachment.length > 0"></vs-divider>

      <!--    첨부파일-->
      <vs-row
        v-if="post.post_attachment && post.post_attachment.length > 0"
        class="read-layout-2">
        <vs-col class="read-layout-title top">첨부파일</vs-col>
        <vs-col>
          <vs-upload class="read-vs-upload" ref="vs_read" :show-upload-button="false" disabled></vs-upload>
        </vs-col>
      </vs-row>

    </vx-card>

    <!-- 답글작성 -->

    <vx-card>

      <div class="flex flex-wrap items-center justify-between">
        <vs-input class="w-full" v-model="form.title" label="제목"></vs-input>
      </div>

      <div class="flex flex-wrap items-center vx-row mt-5">
        <quill-editor class="vx-col flex-1 ql-edit-text" v-model="form.content" :options="quillOption"></quill-editor>
      </div>

      <!--    파일첨부-->
      <div>
        <vs-upload ref="vs_upload" :action="fileUpLoadAction"
                   :headers="fileUpLoadHeaders" @change="handleChangeFile" @on-success="handleSuccessFileUpload" @on-delete="handleDeleteFile"
                   automatic file-name="file_data" :show-upload-button="false" limit="5"></vs-upload>
      </div>

      <div class="flex flex-wrap items-center justify-center">
        <vs-button class="my-5" @click="handleClickRegister">작성</vs-button>
        <vs-button class="ml-5" @click="handleClickCancel" type="border">취소</vs-button>
      </div>

    </vx-card>

  </div>
</template>

<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import {quillEditor} from 'vue-quill-editor'

export default {
  name: 'TemplateReplyNormal',
  components: {
    quillEditor
  },

  props: {
    isAuthor: { type: Boolean, default: false },

    post: Object,
    prevPost: Object, // prevPost = {title, postId}
    nextPost: Object, // nextPost = {title, postId}

    // 파일 업로드 URL
    fileUpLoadHeaders: Object,
    fileUpLoadAction: String
  },

  watch: {
    post () {
      const attachment = this.post.post_attachment
      for (let i = 0; i < attachment.length; i++) {
        this.setVsUploadImage(this, attachment[i].path)
      }
      this.form.title = `[답글] ${this.post.post_title}`
    }
  },

  data () {
    return {
      quillOption: {
        placeholder: '내용을 입력해주세요 .'
      },

      form: {
        title:'',
        content:''
      }
    }
  },

  methods: {

    // vs-upload에 초기 이미지 넣기
    setVsUploadImage (_t, src) {
      let orientation = 'h'
      const image = new Image()
      image.src = src
      image.onload = function () {
        if (this.width > this.height) {
          orientation = 'w'
        }
        _t.$refs.vs_read.srcs.push({
          src: this.src,
          orientation,
          type: 'image',
          percent: null,
          error: false,
          remove: false
        })
        _t.$refs.vs_read.filesx.push({
          src: this.src,
          orientation,
          type: 'image',
          percent: null,
          error: false,
          remove: false
        })
      }
    },

    handleClickPrevPost () {
      this.$emit('handleClickPrevPost', this.prevPost)
    },

    handleClickNextPost () {
      this.$emit('handleClickNextPost', this.nextPost)
    },

    handleClickRegister () {
      const title = this.form.title
      const content = this.form.content
      this.$emit('handleClickRegister', title, content)
    },
    handleClickCancel () {
      this.$emit('handleClickCancel')
    },

    handleChangeFile (path, files) {
      this.$emit('handleChangeFile', path, files)
    },

    handleSuccessFileUpload (event) {
      // response
      let response = event.currentTarget.response
      response = JSON.parse(response)
      const uploadedFileID = response.id
      this.$emit('handleSuccessFileUpload', uploadedFileID)
    },

    handleDeleteFile (file) {
      this.$emit('handleDeleteFile', file)
    }
  }
}
</script>

<style scoped>
.content-read {
  min-height: 20em;
  line-height: 1.6;
}

.read-layout-flex {
  display: flex !important;
}
.read-layout-2 {
  display: grid !important;
  grid-template-columns: 60px 1fr;
  margin-bottom:1.5rem;
}
.read-layout-flex .read-layout-item {
  display: flex;
  min-width:2.8rem;
  width: auto !important;
  margin-right: 5rem;
  margin-top:0.5rem;
  margin-bottom: 0.5rem;
}
.read-layout-flex .read-layout-item h5 {
  display: block;
  font-size:1rem;
  min-width:2.8rem;

  color:#2c2c2c
}
.read-layout-flex .read-layout-item span {
  font-size:1rem;
  margin-left:2rem;
}
.read-layout-title {
  font-weight: bold;
  display: flex;
  align-items: center;
}
.read-layout-title.top{
  align-items: start;
}

.read-layout-footer .read-layout-title{
  height:100%;
  justify-content: center;

  background-color: #EDEDED;
}
.read-layout-footer span {
  height:100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}

</style>

<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}

.read-vs-upload .btn-x-file {
  visibility: hidden;
}

</style>
